export * from './cards.js';
export * from './rules.js';
export * from './messages.js';
export const ROOM_NAMES = {
    RANKED: 'dalmuti_ranked',
    CASUAL: 'dalmuti_casual',
    DALMUTI: 'dalmuti',
    LOBBY: 'lobby',
};
